import React, { useState, useEffect } from 'react';
import Pin from "./Pin";
import { database } from "../firebase"

export default function Pins() {
  const [todoList, setTodoList] = useState();

  useEffect(() => {
    const pinList = database.ref('/Pins');
    pinList.on('value', (snapshot) => {
      const pins = snapshot.val();
      const todoList = [];
      for (let id in pins) {
        todoList.push({ id, ...pins[id] });
      }
      setTodoList(todoList);
    });
  }, []);
  return (
    <div className="PinsContainer w-100">
     {todoList && todoList.map((Pindata, index) =>
                        <Pin key={index}
                          PinId={Pindata.id}
                          PinName={Pindata.name}
                          PinAmount={Pindata.amount}
                          PinBox={Pindata.box}
                          PinPrice={Pindata.price}
                         />
                    )}
    </div>
  );
}
